import { ITimeInterval } from '@cbridge-utils/timezone';
import { IApiSchedule, IApiScheduleData, IApiScheduleFullView, IApiScheduleIntervalDay, IApiScheduleDetails } from '@cbridge-packages/api';
import { ISchedule, IScheduleFullView, IScheduleForm, IScheduleDetails } from './schedule.interface';

export namespace ScheduleTranslator {
  export function fromApi(schedule: IApiSchedule): ISchedule {
    return {
      scheduleId: schedule.id,
      scheduleName: schedule.name,
      timezone: schedule.city,
    };
  }

  export function toApi(schedule: ISchedule): IApiScheduleData {
    return {
      name: schedule.scheduleName,
      city: schedule.timezone,
      cloneScheduleId: schedule.cloneScheduleId,
    };
  }

  const intervalDayReducer = (acc: Record<number, ITimeInterval[]>, day: IApiScheduleIntervalDay) => {
    const interval: ITimeInterval = {
      start: day.start,
      end: day.end,
    };

    if (!acc[day.dayOfWeek]) {
      acc[day.dayOfWeek] = [interval];
    } else {
      acc[day.dayOfWeek].push(interval);
    }

    return acc;
  };

  export function fromApiFullView(schedule: IApiScheduleFullView): IScheduleFullView {
    return {
      ...ScheduleTranslator.fromApi(schedule),
      pricingIntervals: schedule.pricingIntervals?.reduce(intervalDayReducer, {}),
      tradingIntervals: schedule.tradingIntervals?.reduce(intervalDayReducer, {}),
    };
  }

  export function fromApiDetails(schedule: IApiScheduleDetails): IScheduleDetails {
    return {
      ...ScheduleTranslator.fromApiFullView(schedule),
      coreSymbolCount: schedule.coreSymbolCount,
      lps: schedule.lps ?? [],
    };
  }

  export function toFormData(schedule: IScheduleFullView): IScheduleForm {
    if (!schedule) {
      return schedule;
    }
    const {
      scheduleId, scheduleName, timezone, pricingIntervals, tradingIntervals,
    } = schedule;

    return {
      scheduleId, scheduleName, timezone, pricingIntervals, tradingIntervals,
    };
  }
}
